import { ModalService } from './modal.service';
import { RestApiService } from './rest-api.service';
import { AnalyticsService } from './analytics.service';
import { LoggerService } from './logger.service';
import { StorageService } from './storage.service';
import { CookieConsentService } from './cookie-consent.service';
import { ValidatorService } from './validator.service';

export * from './modal.service';
export * from './rest-api.service';
export * from './logger.service';
export * from './analytics.service';
export * from './storage.service';
export * from './cookie-consent.service';
export * from './validator.service';

export const UI_KIT_SERVICES = [
  ModalService,
  RestApiService,
  AnalyticsService,
  LoggerService,
  StorageService,
  CookieConsentService,
  ValidatorService,
];
